'use strict';

export const nn = {
    name: 'nn',
    closeText: 'Lukk',
    prevText: '&#xAB;Førre',
    nextText: 'Neste&#xBB;',
    currentText: 'I dag',
    monthNames: ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'],
    monthNamesShort: ['jan', 'feb', 'mar', 'apr', 'mai', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'des'],
    dayNamesShort: ['sun', 'mån', 'tys', 'ons', 'tor', 'fre', 'lau'],
    dayNames: ['sundag', 'måndag', 'tysdag', 'onsdag', 'torsdag', 'fredag', 'laurdag'],
    dayNamesMin: ['su', 'må', 'ty', 'on', 'to', 'fr', 'la'],
    weekHeader: 'Veke',
    dateFormat: 'dd.mm.yy',
    firstDay: 1,
    isRTL: !1,
    showMonthAfterYear: !1,
    yearSuffix: ''
};
